import React, { forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';

import loadingSpinner from '../../../img/loading-spinner.gif';

type Props = HTMLAttributes<HTMLImageElement> & {
    readonly width?: number;
    readonly className?: string;
};

const LoadingSpinner = forwardRef<HTMLImageElement, Props>(({ width, className, ...imgProps }, ref) => {
    return (
        <img
            {...imgProps}
            ref={ref}
            data-displayname="LoadingSpinner"
            src={loadingSpinner}
            className={classNames('loadingSpinner', className)}
            style={{ width: width ? `${width}px` : undefined }}
        />
    );
});

export default LoadingSpinner;
